import { createFileRoute } from "@tanstack/react-router";

import { AdminBilling } from "@/features/admin/components/AdminBilling";

/**
 * Billing route — platform-admin control-plane for Metronome usage billing
 * (global + per-tenant markup, settlement channel, credits, invoices).
 * Access-gated by the ``/_authed/_modal/admin`` parent (``isPlatformAdmin``).
 */
export const Route = createFileRoute("/_authed/_modal/admin/billing")({
  component: AdminBilling,
});
